import React, { useCallback, useEffect, useRef, useState } from "react";
import { useAppState } from "../contexts/AppContext";
import { Link } from "react-router-dom";
import Pagination from "../components/Pagination";
import ListHeader from "../components/ListHeader";
import { getCollections } from "../helpers/Collections";


export default function Collections() {
    const [loading, setLoading] = useState(false);

    const [search, setSearch] = useState<string | null>(null)
    const [collections, setCollections] = useState<Array<any>>([])
    const [page, setPage] = useState<number>(1)
    const [meta, setMeta] = useState<any>({
        page: 1,
        totalPages: 1,
    });
    const abortController = useRef<AbortController>();


    const getCollectionsFn = useCallback(() => {
        setLoading(true);

        if (abortController.current) {
            abortController.current.abort()
        }

        abortController.current = new AbortController();

        getCollections(50, page, search, { signal: abortController.current.signal }).then((result) => {
            setCollections(result.data)
            setMeta({
                page: result.current_page,
                totalPages: result.last_page,
            })
            setLoading(false);
        }).catch((error) => {
            if (error.name === 'AbortError') {
                return;
            }

            setLoading(false);
        })
    }, [page, search])

    useEffect(() => {
        getCollectionsFn()
    }, [page, search])

    useEffect(() => {
        setPage(1);
    }, [search])

    return (
        <>
            <ListHeader
                title="Collections"
                searchPlaceholder="Search by name..."
                onSearch={(v) => {
                    setSearch(v || null);
                    if (page !== 1) setPage(1); else getCollectionsFn();
                }}
                rightActions={
                    <Link
                        to="/collections/create"
                        className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md text-sm"
                    >
                        Create Collection
                    </Link>
                }
            />
            <div className="mt-3 p-3 rounded bg-white">
                {loading ? (
                    <div className="grid min-h-[140px] w-full place-items-center overflow-x-scroll rounded-lg p-6 lg:overflow-visible">
                        <svg className="text-blue-300 w-12 h-12 animate-spin" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"
                            width="24" height="24">
                            <path
                                d="M32 3C35.8083 3 39.5794 3.75011 43.0978 5.20749C46.6163 6.66488 49.8132 8.80101 52.5061 11.4939C55.199 14.1868 57.3351 17.3837 58.7925 20.9022C60.2499 24.4206 61 28.1917 61 32C61 35.8083 60.2499 39.5794 58.7925 43.0978C57.3351 46.6163 55.199 49.8132 52.5061 52.5061C49.8132 55.199 46.6163 57.3351 43.0978 58.7925C39.5794 60.2499 35.8083 61 32 61C28.1917 61 24.4206 60.2499 20.9022 58.7925C17.3837 57.3351 14.1868 55.199 11.4939 52.5061C8.801 49.8132 6.66487 46.6163 5.20749 43.0978C3.7501 39.5794 3 35.8083 3 32C3 28.1917 3.75011 24.4206 5.2075 20.9022C6.66489 17.3837 8.80101 14.1868 11.4939 11.4939C14.1868 8.80099 17.3838 6.66487 20.9022 5.20749C24.4206 3.7501 28.1917 3 32 3L32 3Z"
                                stroke="currentColor" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"></path>
                            <path
                                d="M32 3C36.5778 3 41.0906 4.08374 45.1692 6.16256C49.2477 8.24138 52.7762 11.2562 55.466 14.9605C58.1558 18.6647 59.9304 22.9531 60.6448 27.4748C61.3591 31.9965 60.9928 36.6232 59.5759 40.9762"
                                stroke="currentColor" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" className="text-blue-500">
                            </path>
                        </svg>
                    </div>
                ) : (
                    <table className="w-full">
                        <thead className="text-left">
                            <tr className="border-b-1">
                                <th className="p-2">Id</th>
                                <th className="p-2">Name</th>
                                <th className="p-2 text-right">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {collections.map((collection: any) => {
                                return (
                                    <tr className="border-b-1 border-gray-300">
                                        <td className="p-2">
                                            <Link to={`/collections/${collection.id}`}>{collection.id}</Link>
                                        </td>
                                        <td className="p-2">{collection.name}</td>
                                        <td className="p-2 ">
                                            <ul className="flex justify-end gap-x-2">
                                                <li>
                                                    <Link to={`/collections/${collection.id}`}>Edit</Link>
                                                </li>
                                                <li>
                                                    {/* <a target="_blank" href={invoice.payment_link}>Link</a> */}
                                                </li>
                                            </ul>
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                )}

            </div>
            {collections && collections.length > 0 ? (
                <div className="w-full mt-5">
                    <Pagination page={meta.page} totalPages={meta.totalPages} onCallback={setPage} />
                </div>
            ) : null}

        </>
    );
}
